import React from "react";

const Color: React.FC = () => {
    return (
        <div className="pointer-events-none fixed inset-0 z-[1] h-full w-full bg-gradient-to-t from-bg-dark to-transparent opacity-40"/>
    );
};

export default Color;
